import axios from 'axios';
export const GetRostersTemplate = () => {
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL+`shift/template`);
};
export const GetRostersTemplateDetail = (id: any) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`shift/template-detail?where=` + id
  );
};

export const AddRosterTemplate = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`shift/template/add`,
    obj,
    { headers }
  );
};
export const deleteTemplate = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`shift/template/delete`, obj, {
    headers,
  });
};
export const editTemplate = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`shift/template/update`,
    obj,
    { headers }
  );
};
